import { BrowserRouter, Routes, Route } from "react-router-dom";
import PublicRoute from "./scopeRoute/PublicRoute";
import ProtectedRoute from "./scopeRoute/ProtectedRoute";
import NotFound from "../common/NotFound";
import DashBoard from "../components/Dashboard/DashBoard";
import { DASHBOARD, GLOBAL_SEARCH, INVENTORY, LOGIN, ORGANIZATION, PROFILE, REQUESTS, SET_PASSWORD_PAGE, SUPPLIER, TOOLS, USERS } from "./RouteConstant";
import { useDispatch } from "react-redux";
import { checkSession } from "../redux/action/authAction/AuthAction";
import { useEffect, useState } from "react";
import DashboardLayout from "../components/layout/DashboardLayout";
import Inventory from "../components/Inventory/Inventory";
import Requests from "../components/Requests/Requests";
import Supplier from "../components/Supplier/Supplier";
import Tools from "../components/Tools/Tools";
import Users from "../components/Users/Users";
import Organisation from "../components/Organisation/Organisation";
import Profile from "../components/Profile/Profile";
import Login from "../components/Authenication/Login";
import SetPassword from "../components/Authenication/SetPassword";
import GlobalSearch from "../components/GlobalSearch/GlobalSearch";
import Loader from "../common/Loader";
import AdminRoute from "./scopeRoute/AdminRoute";

export default function AppRoutes() {
  const dispatch = useDispatch();
  const [checkingSession, setCheckingSession] = useState(true);

  useEffect(() => {
    dispatch(checkSession()).finally(() => setCheckingSession(false));
  }, [dispatch]);

  if (checkingSession) {
    return ( <div> <Loader fullScreen text="Checking session..." /> </div> );
  }
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PublicRoute />}>
          <Route path={LOGIN} element={<Login />} />
        </Route>
        <Route path={SET_PASSWORD_PAGE} element={<SetPassword />} />

        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardLayout />}>
            <Route path={DASHBOARD} element={<DashBoard />} />
            <Route path={INVENTORY} element={<Inventory />} />
            <Route path={REQUESTS} element={<Requests />} />
            <Route path={SUPPLIER} element={<Supplier />} />
            <Route path={TOOLS} element={<Tools />} />
            <Route path={PROFILE} element={<Profile />} />
            <Route path={GLOBAL_SEARCH} element={<GlobalSearch />} />

            <Route element={<AdminRoute />}>
              <Route path={USERS} element={<Users />} />
              <Route path={ORGANIZATION} element={<Organisation />} />
            </Route>
          </Route>
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
